import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import {
  changeAvailableLoyaltyPoints,
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints,
  changeUserInfo,
  updateVirtualOfficeLicence
} from '../../slices/auth-slice';
import { hubsData } from './HubsData';
import { MergedPackageModel, TradingPackageModel } from './Maeketplace.types';
import {
  addHubAsync,
  getAkashaHubsAsync,
  getFlipmeCardsAsync,
  getPackageAsync,
  getPackagesAsync,
  getPackagesBigWhaleAsync,
  getPackagesTradingAsync,
  getTravelPackagesAsync,
  purchaseBigWhalePackageAsync,
  purchaseNFTPackageAsync,
  purchaseTradingPackageAsync,
  purchaseTravelPackageAsync,
  getTravelutionSubscriptionsAsync,
  purchaseSubscriptionAsync,
  depositAkashaAsync,
  getDepositAkashaInfoAsync,
  getAkashaWalletSummaryAsync,
  getGuardianNodesAsync,
  purchaseGuardianNodeAsync,
  getDexNetPackagesAsync,
  purchaseDexNetPackageAsync,
  getKriptoTapPackagesAsync,
  purchasekriptoTapPackageAsync
} from './Marketplace.requests';
import { ErrorToast } from '../../components';
import {
  AKASHA,
  BIG_WHALE,
  DASHBOARD,
  DEX_NET,
  KRIPTO_TAP,
  TRADING,
  TRAVEL_PACKAGES
} from '../../routes/routes';
import { removeUsedDiscount } from '../../slices/dashboard-slice';
import { emptyMyHubsDataWhenPackageBuy } from '../../slices/portfolio-slice';
import { DepositStepsEnum } from '../Portfolio/UlxDeposit/types';

export const getMarketplace = createAsyncThunk('getMarketplace', async () => {
  const { data: userPackages } = await getPackageAsync();
  const { data } = await getPackagesAsync();

  let packages = data!.packages;

  const newHubs = packages
    .map((hub) => {
      let item = hubsData.find((i) => i.id === hub.packageId);

      return item
        ? {
            ...item,
            ...hub
          }
        : hub;
    })
    .reverse();

  return {
    hubs: newHubs as MergedPackageModel[],
    userPackages: userPackages!.orders
    // walletAddress: data.data.walletAddress,
    // isFirstGiftAvailable: data.data.isFirstGiftAvailable,
    // currentVirtualOfficeLicence: data.data.currentVirtualOfficeLicence
  };
});

export const getTradingHubs = createAsyncThunk('getTradingHubs', async () => {
  const { data: userPackages } = await getPackageAsync();
  const { data } = await getPackagesTradingAsync();

  let packages = data!.packages;

  const newHubs = packages
    .map((hub) => {
      // let item = hubsData.find((i) => i.id === hub.packageId);

      return {
        ...hub,
        id: hub.packageId,
        title: hub.name
      };
    })
    .reverse();

  return {
    hubs: newHubs as any,
    userPackages: userPackages!.orders
  };
});

export const getBigWhale = createAsyncThunk('getBigWhale', async () => {
  //const { data: userPackages } = await getPackageAsync();
  const { data } = await getPackagesBigWhaleAsync();

  let packages = data!.packages;

  const newHubs = packages
    .map((hub) => {
      // let item = hubsData.find((i) => i.id === hub.packageId);

      return {
        ...hub,
        id: hub.packageId,
        title: hub.name,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits
      };
    })
    .reverse();

  return {
    hubs: newHubs as any
    //userPackages: userPackages!.orders
  };
});

export const getTravelPackages = createAsyncThunk(
  'getTravelPackages',
  async () => {
    const { data } = await getTravelPackagesAsync();

    let packages = data!.packages;

    const newHubs = packages.map((hub) => {
      return {
        ...hub,
        id: hub.packageId,
        title: hub.name,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits,
        tickets: `+${hub.tickets} ${hub.tickets !== 5 ? 'ticket' : 'tickets'}`
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: [] // userPackages!.orders
    };
  }
);

export const getTravelutionSubscriptions = createAsyncThunk(
  'getTravelutionSubscriptions',
  async () => {
    const { data } = await getTravelutionSubscriptionsAsync();
    let packages = data!.subscriptions;
    const newHubs = packages.map((hub: any) => {
      return {
        ...hub,
        id: hub.id,
        packageId: hub.id,
        title: hub.name,
        subtitle: `+ ${hub.myLifePoints}`,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits,
        tickets: 'MYLIFE POINTS'
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: [] // userPackages!.orders
    };
  }
);

export const getFlipmeCards = createAsyncThunk('getFlipmeCards', async () => {
  const { data } = await getFlipmeCardsAsync();

  let packages = data!.packages;

  const newHubs = packages.map((hub) => {
    return {
      ...hub,
      id: hub.packageId,
      title: hub.name,
      willyMemeCoins: hub.price,
      whaleBenefits: hub.benefits,
      tickets: hub.subtitle2
    };
  });
  return {
    hubs: newHubs as any
  };
});

export const getAkashaHubs = createAsyncThunk('getAkashaHubs', async () => {
  const { data } = await getAkashaHubsAsync();

  let packages = data!.packages;

  const newHubs = packages.reverse();

  return {
    hubs: newHubs as any
  };
});

export const getKriptoTapPackages = createAsyncThunk(
  'getKriptoTapPackages',
  async () => {
    const { data } = await getKriptoTapPackagesAsync();

    let packages = data!.packages;

    const newHubs = packages.reverse();

    return {
      hubs: newHubs as any
    };
  }
);

export const getDexNetPackages = createAsyncThunk(
  'getDexNetPackages',
  async () => {
    const { data } = await getDexNetPackagesAsync();

    let packages = data!.packages;

    const newHubs = packages.reverse();

    return {
      hubs: newHubs as any
    };
  }
);

export const getGuardianNodes = createAsyncThunk(
  'getGuardianNodes',
  async () => {
    const { data } = await getGuardianNodesAsync();

    let packages = data!.packages;

    const newHubs = packages.reverse();

    const newVolumePoints: Record<number, number> = {
      240: 250,
      241: 1250,
      242: 3750,
      243: 12500,
      244: 30000,
      245: 50000,
      246: 75000,
      247: 300000,
      248: 500000,
      249: 1000000,
      250: 250,
      251: 1250,
      252: 3750,
      253: 12500,
      254: 30000,
      255: 50000,
      256: 75000,
      257: 300000,
      258: 500000,
      259: 1000000
    };

    const updatedArray = newHubs.map((pkg) => {
      if (newVolumePoints[pkg.packageId] !== undefined) {
        return { ...pkg, volumePoints: newVolumePoints[pkg.packageId] };
      }
      return pkg;
    });

    return {
      hubs: updatedArray as any
    };
  }
);

export const getDepositAkashaInfo = createAsyncThunk(
  'getDepositAkashaInfo',
  async ({ userPackageId }: { userPackageId: string }) => {
    try {
      const { data } = await getDepositAkashaInfoAsync({
        userPackageId
      });

      return data;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const getAkashaWalletSummary = createAsyncThunk(
  'getAkashaWalletSummary',
  async () => {
    const { data } = await getAkashaWalletSummaryAsync();

    return {
      walletSummary: data?.walletSummary,
      exchangeRates: data?.exchangeRates
    };
  }
);

export const depositAkasha = createAsyncThunk(
  'depositAkasha',
  async (
    {
      userPackageId,
      amount,
      token,
      chain,
      getBalance,
      setStep
    }: {
      userPackageId: number;
      amount: number;
      token: string | undefined;
      chain: string;
      getBalance: any;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await depositAkashaAsync({
        userPackageId,
        amount,
        token,
        chain
      });

      getBalance();

      dispatch(
        getDepositAkashaInfo({ userPackageId: userPackageId.toString() })
      );

      setStep(DepositStepsEnum.FINISH);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const addHub = createAsyncThunk(
  'addHub',
  async (
    {
      packageId,
      currencyType,
      networkType,
      licenceId,
      userDiscountCodeId,
      step,
      setStep
    }: {
      packageId: number;
      currencyType: number;
      networkType: number | null;
      licenceId: number | null;
      userDiscountCodeId: number | null;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await addHubAsync({
        packageId,
        currencyType,
        networkType,
        licenceId,
        userDiscountCodeId
      });

      const state = getState() as RootState;

      setStep(step);

      if (currencyType === 3) {
        dispatch(
          changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
        );
      } else if (currencyType === 2) {
        dispatch(
          changeAvailableShoppingPoints(data!.userTickets.shoppingPoints)
        );
      } else if (currencyType === 4) {
        dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));
      }

      if (licenceId !== null) {
        dispatch(updateVirtualOfficeLicence(data!.userVirtualOfficeLicence));

        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets,
            currentVirtualOfficeLicence: data!.userVirtualOfficeLicence
          }
        };

        setUserToLS(user);
      } else {
        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets
          }
        };

        setUserToLS(user);
      }

      return {
        userPackage: data!.userPackage,
        currencyType
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const purchasePackage = createAsyncThunk(
  'purchasePackage',
  async (
    {
      packageId,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc,
      networkType,
      userDiscountCodeId,
      handleSuccess
    }: {
      packageId: number;
      networkType: number | null;
      licenceId: number | null;
      userDiscountCodeId: number | null;
      lp: number;
      club: number;
      cash: number;
      usdt: number;
      usdc: number;
      handleSuccess: () => void;
    },
    { dispatch, getState }
  ) => {
    try {
      let data;

      switch (window.location.pathname) {
        case TRAVEL_PACKAGES: {
          if (packageId === 1 || packageId === 2) {
            const res = await purchaseSubscriptionAsync({
              packageId,
              networkType,
              licenceId,
              lp,
              club,
              cash,
              usdt,
              usdc
            });
            data = res.data;
          } else {
            const res = await purchaseTravelPackageAsync({
              packageId,
              networkType,
              licenceId,
              lp,
              club,
              cash,
              usdt,
              usdc
            });
            data = res.data;
          }
          break;
        }

        case BIG_WHALE: {
          const res = await purchaseBigWhalePackageAsync({
            packageId,
            networkType,
            licenceId,
            lp,
            club,
            cash,
            usdt,
            usdc
          });

          data = res.data;
          break;
        }

        case DASHBOARD:
        case TRADING: {
          const res = await purchaseTradingPackageAsync({
            packageId,
            networkType,
            licenceId,
            lp,
            club,
            cash,
            usdt,
            usdc,
            userDiscountCodeId
          });

          data = res.data;
          break;
        }

        case AKASHA: {
          const res = await purchaseGuardianNodeAsync({
            packageId,
            networkType,
            licenceId,
            lp,
            club,
            cash,
            usdt,
            usdc
          });

          data = res.data;
          break;
        }

        case DEX_NET: {
          const res = await purchaseDexNetPackageAsync({
            packageId,
            networkType,
            licenceId,
            lp,
            club,
            cash,
            usdt,
            usdc
          });

          data = res.data;
          break;
        }

        case KRIPTO_TAP: {
          const res = await purchasekriptoTapPackageAsync({
            packageId,
            networkType,
            licenceId,
            lp,
            club,
            cash,
            usdt,
            usdc
          });

          data = res.data;
          break;
        }

        default:
          {
            const res = await purchaseNFTPackageAsync({
              packageId,
              networkType,
              licenceId,
              lp,
              club,
              cash,
              usdt,
              usdc
            });

            data = res.data;
          }
          break;
      }

      const state = getState() as RootState;

      handleSuccess();

      dispatch(
        changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
      );
      dispatch(changeAvailableShoppingPoints(data!.userTickets.shoppingPoints));
      dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));

      if (licenceId !== null) {
        dispatch(updateVirtualOfficeLicence(data!.userVirtualOfficeLicence));

        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets,
            currentVirtualOfficeLicence: data!.userVirtualOfficeLicence
          }
        };

        setUserToLS(user);
      } else {
        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets
          }
        };

        setUserToLS(user);
      }

      if (userDiscountCodeId) {
        dispatch(removeUsedDiscount(userDiscountCodeId));
      }

      dispatch(emptyMyHubsDataWhenPackageBuy());

      const userPackage = data!.userPackage;
      const subscription = data?.subscription;

      return {
        userPackage,
        subscription
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
